import { render, staticRenderFns } from "./ContextItemOverview.vue?vue&type=template&id=c1e2b622&scoped=true"
import script from "./ContextItemOverview.vue?vue&type=script&lang=js"
export * from "./ContextItemOverview.vue?vue&type=script&lang=js"
import style0 from "./ContextItemOverview.vue?vue&type=style&index=0&id=c1e2b622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e2b622",
  null
  
)

export default component.exports